import React from 'react'
import styled from 'styled-components'
import Rects from './Svg/Rects'
import { Link } from 'gatsby'

const Wrap = styled.div`
    margin-top:200px;
    margin-bottom:100px;
    position: relative;
  
`
const Wrapper = styled.div`
    margin: 0 40px;
    position: relative;
    @media screen and (max-width: 545px) {
        margin: 0 16px;
    }
    svg {
    align-self: flex-start;
}
@media screen and (max-width:545px) {
       svg {
        width: 35px;
    height: 40px;
       } 
    }
`
const TitleWrap  = styled.div`
        display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 60px;
    gap: 1rem;
    @media screen and (max-width:545px) {
        gap: 8px;
    }
`
const Title = styled.h1`
font-weight: 700;
font-size: 40px;
line-height: 44px;
color: #39394C;
margin-top: -.5rem;

@media screen and (max-width: 545px) {
    font-size: 30px;
    }
    
`
const GridTwo = styled.div`
    display: grid;
grid-template-columns: repeat(3,1fr);
column-gap: 90px;
place-items: flex-start;
margin-bottom: 4rem;
@media screen and (max-width:607px) {
        column-gap: 50px;
    }
    @media screen and (max-width:450px) {
        column-gap: 20px;
    }
@media screen and (max-width: 1214px) {
        grid-template-columns: repeat(2,1fr);
  
    }
    @media screen and (max-width:545px) {
        grid-template-columns: repeat(1,1fr);
    }
position: relative;

    /* &::after {
        content: '';
        left: 0;
    position: absolute;
    height: 1px;
    width: 100%;
    background: #D4DBE2;
    bottom: -5rem;
    } */

`
const Grid = styled.div`
display: grid;
grid-template-columns: repeat(3,1fr);
column-gap: 100px;
place-items: flex-start;
@media screen and (max-width:607px) {
        column-gap: 50px;
    }
    @media screen and (max-width:450px) {
        column-gap: 20px;
    }
@media screen and (max-width: 1214px) {
        grid-template-columns: repeat(2,1fr);
        .ideas {
            margin-top: -1rem;
        }
    }
    /* @media screen and (max-width:500px) {
        grid-template-columns: repeat(1,1fr);
    } */
position: relative;

`
const GridItem = styled.div`
    margin-top: 1rem;
`
const GridTitle = styled.h3`
    font-weight: 600;
font-size: 24px;
line-height: 28px;
color: #39394C;

`
const GridParagraph  = styled.p`
font-family: 'Outfit';
font-style: normal;
font-weight: 300;
font-size: 24px;
line-height: 36px;
/* or 150% */


/* Blue */

color: #39394C;

opacity: 0.6;
`
const LargeNumber = styled.h1`
    font-weight: 700;
font-size: 128px;
line-height: 128px;
text-align: center;
color: #39394C;
position: relative;
@media screen and (max-width:700px) {
    font-size: 90px;
}
@media screen and (max-width:545px) {
    font-size: 64px;
}
`
const Span = styled.span`
    font-weight: 300;
font-size: 24px;
line-height: 36px;
color: #39394C;
margin-left: 1rem;
@media screen and (max-width: 700px) {
        font-size: 20px;
    }
    @media screen and (max-width:545px) {
    font-size: 16px;
}
`
const ButtonWrap = styled.div`
background: #F5F6F7;
border-radius: 32px;
display: flex;
flex-direction: row;
padding: 83px 72px;
align-items: center;
gap: 64px;
@media screen and (max-width: 920px) {
    flex-direction: column;
    gap: 0;
}
@media screen and (max-width: 500px) {
    padding: 83px 0;
}
/* @media screen and (max-width: 1438px) {
    padding: 76px 180px;
}
@media screen and (max-width: 1370px) {
    padding: 76px 140px;
}
@media screen and (max-width: 1290px) {
    gap: 0;
}
@media screen and (max-width: 1250px) {
    padding: 76px 100px;
}
@media screen and (max-width: 1170px) {
    padding: 76px 70px;
}
@media screen and (max-width: 850px) {
    padding: 45px 60px;
}
@media screen and (max-width: 800px) {
    flex-direction: column;
}
@media screen and (max-width: 580px) {
    padding: 45px 0;
} */

`
const Button = styled(Link)`
    background: #FF4C55;
border-radius: 60px;
display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
padding: 20px 89px;
font-family: 'Outfit';
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 20px;
text-align: center;
color: #FFFFFF;
@media screen and (max-width: 1030px) {
    padding:15px 75px;
}
@media screen and (max-width: 820px) {
    padding: 10px 60px;
}
`
const Ideas = styled.span`
        font-weight: 300;
font-size: 24px;
line-height: 36px;
color: #39394C;
margin-left: 1rem;
@media screen and (max-width: 700px) {
        font-size: 20px;
    }
    @media screen and (max-width:545px) {
    font-size: 16px !important;
    left: 2.5rem !important;
    width: 114px !important;
    line-height: 1.5 !important;
    bottom: 2.2rem !important;
}
    @media screen and (max-width:556px) {
       display: -webkit-box;
    left: 4rem;
    /* font-size: 13px; */
    width: 131px;
    bottom: 1.2rem;
    display: -webkit-flex;
    position: absolute;
    /* width: 100%; */
    display: -ms-flexbox;
    text-align: start;
    display: -webkit-box;
    /* padding: 0 6rem; */
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    -ms-flex-pack: end;
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    }
`
const Experience = styled.span`
font-weight: 300;
    /* width: 100%; */
    font-size: 24px;
    line-height: 36px;
    color: #39394C;
    /* margin-left: 18rem; */
    display: -webkit-box;
    left: 11rem;
    bottom: 0.5rem;
    display: -webkit-flex;
    position: absolute;
    display: -ms-flexbox;

    text-align: start;
    display: flex;
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    margin-top: -5rem;
    @media screen and (max-width: 700px) {
        font-size: 20px;
        left: 7rem;
    bottom: 1.5rem;
    }
    @media screen and (max-width:545px) {
    font-size: 16px;
    left: 5rem;
    bottom: 2.3rem;
    
    line-height: 1.5;
}
`
const TitleBtn = styled.div`
display: flex;
flex-direction: row;
gap :1rem;
align-items: center;
flex: 1;
svg {
    align-self: center;
}
@media screen and (max-width: 930px) {
    svg {
        width: 35px;
    }
}
`
const TitleButton = styled.h1`
    font-family: 'Outfit';
font-style: normal;
font-weight: 700;
font-size: 40px;
line-height: 44px;
/* identical to box height, or 110% */


/* Blue */

color: #39394C;
@media screen and (max-width: 1100px) {
    font-size : 35px;
}
@media screen and (max-width: 1000px) {
    font-size : 30px;
}
@media screen and (max-width: 930px) {
    font-size : 25px;
}
@media screen and (max-width: 580px) {
    font-size: 20px;
}
`
interface ValuesProps {
    values:any
}

const Values: React.FC<ValuesProps> = ({values}) => {
    let str = ''
    if(typeof window !== 'undefined') {
        let location = window.location.pathname
        str = location.replace(/^\/([^\/]*).*$/, '$1')
        
    }
        return (
            <Wrap>
                <Wrapper>
                <TitleWrap>
                    <Rects/>
                    <Title>{values.title.text}</Title>
                </TitleWrap>
                <GridTwo>
                    {values.grid.map((value : any) =>
                     <GridItem>
                     <GridTitle>{value.grid_item.document.data.title.text}</GridTitle>
                     <GridParagraph>
                     {value.grid_item.document.data.paragraph.text}
                     </GridParagraph>
                     </GridItem>
                    )}
                   
                </GridTwo>

                
                <ButtonWrap >
                <TitleBtn>
               
                    <TitleButton>{values.btn}</TitleButton>
                </TitleBtn>
                <div>
                <Button to={str === 'fr-fr' ? '/fr-fr/nos-contacter': '/contact'} className='pink'>
                        {str=='fr-fr' ? 'Contactez-nous': " Contact us "}
                    </Button>
                </div>
                   
                </ButtonWrap>
                </Wrapper>
                
            </Wrap>
        );
}
export default Values
